<mat-form-field class="form-field-search">
    <mat-label>{{ label | translate }}</mat-label>
    <input matInput type="text" [(ngModel)]="initialValue" (input)="onInput($event)">
    <button matSuffix mat-icon-button aria-label="Clear" (click)="resetInput()">
        <mat-icon>close</mat-icon>
    </button>
</mat-form-field>